<template>
<div class="">
  <!--{{singleBooking.booking_type_id}}-->
  <div class="" v-if="singleBooking.booking_type_id === 'FF9330A3' || singleBooking.booking_type_id === 'GB601X10'">
    <gate-entry-ticket></gate-entry-ticket>
  </div>
  <div class="" v-if="singleBooking.booking_type_id === 'PB001A20'">
    <tour-operator-booking></tour-operator-booking>
  </div>
  <div class="" v-if="singleBooking.booking_type_id === '8D7E6504'">
    <group-booking></group-booking>
  </div>
  <div class="" v-if="singleBooking.booking_type_id === 'C3237489'">
    <group-booking></group-booking>
  </div>
  <div class="" v-if="singleBooking.booking_type_id === '7769748C'">
    <member-booking></member-booking>
  </div>
</div>
</template>

<script>
import BookingVuex from '../../../mixins/Computed/Booking/BookingVuex'
import GateEntryTicket from './Snippets/GateEntryTicket'
import TourOperatorBooking from './Snippets/TourOperatorBooking'
import GroupBooking from './Snippets/GroupBooking'
import MemberBooking from './Snippets/MemberBooking'


export default {
  components: { GateEntryTicket, TourOperatorBooking, GroupBooking, MemberBooking },
  name: 'PostponeBooking',
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_booking', this.$route.params.booking_id)
  },
  mixins: [BookingVuex]
}
</script>

<style scoped>

</style>
